<template>
  <div class="control-input">
    <input 
      type="text"
      :placeholder="ikey"
      :readonly="readonly"
      :value="value"
      @input="change($event)"
      @dblclick.stop=""
      @pointerdown.stop=""
      @pointermove.stop=""
    />
  </div>
</template>

<script>
  export default {
    name: 'VueTextControl',
    props: ['readonly', 'emitter', 'ikey', 'getData', 'putData'],
    data: () => {
      return {
        value: '...',
      }
    },
    methods: {
      // The following method onChange() looks as if it is not used. This is NOT true.
      // This method is overwritten by the module, input and output components. Do not delete.
      onChange() {},
      change(e) {
        this.value = e.target.value;
        this.update();
        // The following line of code must remain
        this.onChange();
      },
      update() {
        if (this.ikey)
          this.putData(this.ikey, this.value)
        this.emitter.trigger('process');
      }
    },
    mounted() {
      this.value = this.getData(this.ikey) || '...';
      this.update;
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /*.node .control-input {
    padding: 6px 18px;
  }*/
</style>
